import React, { useState } from 'react';
import { App, Button, Dropdown, Form, InputNumber, Space, Spin, Tooltip } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { PrinterOutlined, DeleteOutlined, FieldNumberOutlined, FlagOutlined, MinusOutlined, OrderedListOutlined, PartitionOutlined, PlusOutlined, RetweetOutlined, SortAscendingOutlined, SortDescendingOutlined, SwapOutlined, TagOutlined, TeamOutlined, UsergroupDeleteOutlined, AuditOutlined, LineChartOutlined, TrophyOutlined, FileTextOutlined } from '@ant-design/icons';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RoundItem = models.rounds.RoundItem;
var ClassRoundSource = models.rounds.ClassRoundSource;
var RoundJudgeSource = models.judges.RoundJudgeSource;
var SessionState = hooks.sessions.SessionState;
var useSession = hooks.sessions.useSession;
import { JudgeType, JudgingType, RoundStatus } from '@vote4dance/judging-schema';
import { SeparatePosition } from './SeparatePosition';
import { safeDeleteRound } from '../utilities';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
export const RoundToolbar = (props) => {
    const { round, disabled, onClickStatistics } = props;
    const { modal, notification } = App.useApp();
    const [inputCompetition, event, competitions, loading] = useCompetition(round.competition_id);
    const [form] = Form.useForm();
    const [loadingButton, setLoadingButton] = useState(null);
    const [judges, loadingJudges] = Stream(RoundJudgeSource(round.competition_id, round.round_id));
    const [isSeparatePositionVisible, setIsSeparatePositionVisible] = useState(false);
    const [separatePositionMethod, setSeparatePositionMethod] = useState('redance');
    const [overrideUseAllJudges, setOverrideUseAllJudges] = useState(false);
    const [overrideTitle, setOverrideTitle] = useState();
    const sessionState = useSession();
    const navigate = useNavigate();
    const classRoundSource = ClassRoundSource(round.class_id);
    if (loading || loadingJudges) {
        return React.createElement(Spin, null);
    }
    const isMainRound = !RoundItem.isChildRound(round) || round.round_children > 0;
    const isClosed = round.round_status == RoundStatus.Closed;
    const hasChildRounds = round.round_children > 0;
    const hasTeams = round.round_count > 0;
    const skatingData = RoundItem.getSkatingData(round);
    const hasRedancePositions = skatingData && skatingData.find(data => data.teams && data.teams.length > 1);
    const hasSkatingPositions = skatingData && skatingData.find(data => !!data.sideskated);
    const hasChiefJudge = judges && judges.filter(judge => [JudgeType.ChiefIn, JudgeType.ChiefOut, JudgeType.Observer].includes(judge.judge_type)).length > 0;
    const isPartialInput = round.judging_type === JudgingType.PartialInput;
    const chiefOverrideTitle = _T('round.actions.override.title');
    const paperRedanceTitle = _T('round.actions.override.paperRedance');
    const showRedanceButton = isClosed && isMainRound && hasTeams;
    const showSkatingButton = isClosed && !hasChildRounds && hasTeams && !isPartialInput;
    const showChiefOverrideButton = isClosed && hasTeams && hasChiefJudge;
    const showPaperRedanceButton = isClosed && hasTeams && isPartialInput && !hasChiefJudge;
    const enableStatistics = RoundItem.isFinalRound(round) && event && parseInt(event.usercompetition_level) >= 100 &&
        (event.competition_federation == "SDO" ||
            event.competition_federation == "IDO" ||
            event.competition_federation == "DSV" ||
            (event.competition_federation == "ND" && SessionState.isTester(sessionState)));
    const canDeleteRound = round.round_count == 0 && round.round_status == 'open';
    const canClearTeams = round.round_count > 0 && round.round_status == 'open';
    const canChangeSorting = [RoundStatus.Open, RoundStatus.Ready].includes(round.round_status);
    const canChangeHeats = round.round_count > 0 && [RoundStatus.Open, RoundStatus.Ready].includes(round.round_status);
    const clearTeams = async (item, done) => {
        await Api.call(`${classRoundSource.url}/${round.round_id}`, "clear-teams")
            .catch((err) => {
            var _a;
            notification.error({
                message: err.message || ((_a = err.response) === null || _a === void 0 ? void 0 : _a.message)
            });
        });
        done();
    };
    const setOrder = (order, field, maxPerHeat) => {
        const confirmModal = modal.confirm({
            title: _T('round.order.' + order),
            content: React.createElement(Space, { orientation: 'vertical' },
                _T('common.confirm'),
                order == 'sort' && field != 'team_start_number' &&
                    React.createElement(Form, { form: form, layout: "vertical", name: "maxPerHeat", initialValues: { maxPerHeat: 3 } },
                        React.createElement(Form.Item, { name: "maxPerHeat" },
                            React.createElement(InputNumber, { autoFocus: true, prefix: React.createElement(TeamOutlined, null), min: 0, addonBefore: "Max", addonAfter: "Per heat" })))),
            onOk() {
                form
                    .validateFields()
                    .then((values) => {
                    form.resetFields();
                    confirmModal.update({
                        okButtonProps: { loading: true },
                        cancelButtonProps: { disabled: true }
                    });
                    Api.call(`${classRoundSource.url}/${round.round_id}`, order + "-team-order", { field, maxPerHeat: values['maxPerHeat'] })
                        .then(() => {
                        confirmModal.update({
                            okButtonProps: { loading: false },
                            cancelButtonProps: { disabled: false }
                        });
                    })
                        .catch((err) => {
                        confirmModal.update({
                            okButtonProps: { loading: false },
                            cancelButtonProps: { disabled: false }
                        });
                        notification.error({
                            message: _T(err.name)
                        });
                    });
                });
            }
        });
    };
    const incrementHeat = (increment) => {
        var updateItem = { ...round };
        updateItem.round_num_heats = round.round_num_heats + increment;
        setLoadingButton('round_num_heats');
        Api.update(`${classRoundSource.url}/${round.round_id}`, updateItem)
            .then(() => {
            setLoadingButton(null);
        })
            .catch((err) => {
            notification.error({
                message: _T(err.name)
            });
            setLoadingButton(null);
        });
    };
    const handleSortMenuClick = (e) => {
        setOrder('sort', e.key);
    };
    const sortOrderItems = [
        {
            key: 'team_start_number',
            icon: React.createElement(FieldNumberOutlined, null),
            label: _T('team.details.team_start_number.label'),
        },
        {
            key: 'team_org',
            icon: React.createElement(TeamOutlined, null),
            label: _T('team.details.team_org.label'),
        },
        {
            key: 'team_country',
            icon: React.createElement(FlagOutlined, null),
            label: _T('team.details.team_country.label'),
        },
        {
            key: 'team_show_name',
            icon: React.createElement(TagOutlined, null),
            label: _T('team.details.team_show_name.label'),
        },
    ];
    const handleHeatMenuClick = (e) => {
        incrementHeat(e.key == 'add_heat' ? 1 : -1);
    };
    const heatItems = [
        {
            key: 'add_heat',
            icon: React.createElement(PlusOutlined, null),
            label: _T('round.details.round_num_heats.add'),
            disabled: round.round_num_heats >= round.round_count
        },
        {
            key: 'remove_heat',
            icon: React.createElement(MinusOutlined, null),
            label: _T('round.details.round_num_heats.remove'),
            disabled: round.round_num_heats === 0
        },
    ];
    const printItems = [
        {
            key: 'print_heat',
            icon: React.createElement(PartitionOutlined, null),
            label: React.createElement(Link, { target: "_blank", to: `/print/${round.competition_id}/heat/${round.class_id}/${round.round_id}` }, _T('round.heat'))
        },
        {
            key: 'print_judging_sheet',
            icon: React.createElement(FileTextOutlined, null),
            label: React.createElement(Link, { target: "_blank", to: `/print/${round.competition_id}/judging-sheet/${round.class_id}/${round.round_id}` }, _T('judges.plural'))
        },
        {
            key: 'print_diploma',
            icon: React.createElement(AuditOutlined, null),
            label: React.createElement(Link, { target: "_blank", to: `/print/${round.competition_id}/diploma/${round.class_id}/${round.round_id}` }, _T('print.diploma.title'))
        },
        {
            key: 'print_result',
            icon: React.createElement(TrophyOutlined, null),
            label: React.createElement(Link, { target: "_blank", to: `/print/${round.competition_id}/result/${round.class_id}/${round.round_id}` }, _T('round.details.results.label')),
            disabled: parseInt(round.round_parent_id) > 0
        }
    ];
    const separatePosition = (method, options) => {
        setSeparatePositionMethod(method);
        setOverrideUseAllJudges((options === null || options === void 0 ? void 0 : options.overrideUseAllJudges) || false);
        setOverrideTitle(options === null || options === void 0 ? void 0 : options.overrideTitle);
        setIsSeparatePositionVisible(true);
    };
    const deleteRound = async (item, done) => {
        await safeDeleteRound(round, modal);
        done();
        navigate(parseInt(round.round_parent_id) > 0 ? `../classes/${round.class_id}/${round.round_parent_id}` : '../classes');
    };
    return (React.createElement(Space, { size: [8, 8], wrap: true },
        showRedanceButton &&
            React.createElement(Tooltip, { title: _T('round.actions.redance.info') },
                React.createElement(Button, { type: "primary", disabled: !hasRedancePositions || disabled, icon: React.createElement(RetweetOutlined, null), onClick: () => separatePosition("redance") }, _T('round.actions.redance.title'))),
        showSkatingButton &&
            React.createElement(Tooltip, { title: _T('round.actions.sideSkating.info') },
                React.createElement(Button, { disabled: !hasSkatingPositions || disabled, icon: React.createElement(OrderedListOutlined, null), onClick: () => separatePosition("sideSkating") }, _T('round.actions.sideSkating.title'))),
        showChiefOverrideButton &&
            React.createElement(Tooltip, { title: _T('round.actions.override.info') },
                React.createElement(Button, { disabled: !hasRedancePositions || disabled, icon: React.createElement(OrderedListOutlined, null), onClick: () => separatePosition("override", {
                        overrideUseAllJudges: false,
                        overrideTitle: chiefOverrideTitle
                    }) }, chiefOverrideTitle)),
        showPaperRedanceButton &&
            React.createElement(Tooltip, { title: _T('round.actions.sideSkating.info') },
                React.createElement(Button, { disabled: !hasRedancePositions || disabled, icon: React.createElement(OrderedListOutlined, null), onClick: () => separatePosition("override", {
                        overrideUseAllJudges: true,
                        overrideTitle: paperRedanceTitle
                    }) }, paperRedanceTitle)),
        React.createElement(Space.Compact, null,
            React.createElement(ButtonConfirm, { title: '', description: _T('common.delete.content', { name: _T('round.title').toLowerCase() }), tooltip: _T('common.delete.title', { name: _T('round.title').toLowerCase() }), onConfirm: done => deleteRound(round, done), buttonProps: {
                    disabled: !canDeleteRound || disabled,
                    icon: React.createElement(DeleteOutlined, null)
                } }),
            React.createElement(ButtonConfirm, { title: '', description: _T('common.delete.content', { name: _T('team.title').toLowerCase() }), tooltip: _T(`round.clearTeams`), onConfirm: done => clearTeams(round, done), buttonProps: {
                    disabled: !canClearTeams || disabled,
                    icon: React.createElement(UsergroupDeleteOutlined, null)
                } }),
            React.createElement(Tooltip, { title: _T(`round.order.randomize`) },
                React.createElement(Button, { disabled: !canChangeSorting || disabled, icon: React.createElement(SwapOutlined, null), onClick: () => setOrder('randomize') })),
            React.createElement(Dropdown, { disabled: !canChangeSorting || disabled, menu: {
                    items: sortOrderItems,
                    onClick: handleSortMenuClick
                } },
                React.createElement(Tooltip, { title: _T(`round.order.sort`) },
                    React.createElement(Button, { disabled: !canChangeSorting || disabled, icon: React.createElement(SortAscendingOutlined, null) }))),
            React.createElement(Tooltip, { title: _T(`round.order.reverse`) },
                React.createElement(Button, { disabled: !canChangeSorting || disabled, icon: React.createElement(SortDescendingOutlined, null), onClick: () => setOrder('reverse') })),
            React.createElement(Dropdown, { disabled: !canChangeHeats || disabled, menu: {
                    items: heatItems,
                    onClick: handleHeatMenuClick
                } },
                React.createElement(Tooltip, { title: _T(`round.details.round_num_heats.label`) },
                    React.createElement(Button, { disabled: !canChangeHeats || disabled, icon: React.createElement(PartitionOutlined, null), loading: loadingButton == 'round_num_heats' }))),
            React.createElement(Dropdown, { menu: { items: printItems } },
                React.createElement(Tooltip, { title: _T(`common.print`) },
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null) }))),
            enableStatistics &&
                React.createElement(Tooltip, { title: _T(`round.statistics.title`) },
                    React.createElement(Button, { icon: React.createElement(LineChartOutlined, null), onClick: () => onClickStatistics() }))),
        React.createElement(SeparatePosition, { federation_id: inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.federation_id, round: round, method: separatePositionMethod, visible: isSeparatePositionVisible, setVisible: setIsSeparatePositionVisible, disabled: disabled, overrideUseAllJudges: overrideUseAllJudges, overrideTitle: overrideTitle })));
};
